import axios from 'axios';
import { auth } from '../firebase/firebase-config';
import { toast, Toast, ToastContainer } from 'react-toastify';





export async function updateToken() {
    // await auth.currentUser.isAnonymous;
    var _token = await auth.currentUser.getIdToken();
    return _token;
}


export async function basePostAPI(url,
    { body }) {
    var token = await updateToken();
    console.log(token);
    var bearerAuth = `Bearer ${token}`;

    axios.defaults.headers['Accept'] = 'application/json';
    axios.defaults.headers.common['Authorization'] = bearerAuth;
    // axios.defaults.headers.common["access-control-allow-origin"] = *;
    console.log(body);
    // axios.defaults.headers.
    try {
        await axios.post(url, body, {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
            }
        }).then((msg) => {
            console.log(msg.status, msg.data);

            if (msg.status == 200) {
                // if (successMsg != null) {
                toast.success('Signup Successfull', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                })
                // }
                // if (msg.data.isSuccess == false) {
                //     toast.dark('Signup Not Successfull', {
                //         position: "top-right",
                //         autoClose: 5000,
                //         hideProgressBar: false,
                //         closeOnClick: true,
                //         pauseOnHover: true,
                //         draggable: true,
                //         progress: undefined,
                //         theme: "dark",
                //     })
                // }


            }
        }).catch((e) => {
            console.log(e);
        });
    } catch (error) {
        console.log(error);
    };


}

